<template>
  <div class="flex flex-col gap-3">
    <span class="text-sm font-semibold text-[#16161d] text-left">Plantões inclusos</span>
    <div class="w-full overflow-x-auto border border-[#d8d8e2] rounded-lg">
      <table class="w-full min-w-[600px] border-collapse">
        <thead>
          <tr class="bg-[#f0f0f4]">
            <th
              v-for="col in columns"
              :key="col"
              class="px-4 py-2.5 text-sm font-bold text-[#272735] text-center"
            >
              {{ col }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="station in stations"
            :key="station.id"
            class="border-t border-[#e8e8ed] bg-white"
          >
            <td class="px-4 py-2.5 text-center text-[13px] text-[#16161d]">
              {{ formatStationDate(station.date) }}
            </td>
            <td
              class="px-4 py-2.5 text-center text-[13px] text-[#16161d]"
              data-testid="station-time-range-cell"
            >
              {{ formatStationTimeRange(station.startTime, station.endTime, station.timezone) }}
            </td>
            <td class="px-4 py-2.5 text-center text-[13px] text-[#16161d]">
              {{ station.position ?? '-' }}
            </td>
            <td class="px-4 py-2.5 text-center text-[13px] text-[#16161d]">
              {{ station.type ?? '-' }}
            </td>
            <td class="px-4 py-2.5 text-center text-[13px] text-[#16161d]">
              {{ recurrenceLabel }}
            </td>
            <td class="px-4 py-2.5 text-center text-[13px] text-[#16161d]">
              {{ formatValue(station.value) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { format, parseISO } from 'date-fns'
import { StationSummary } from '@/Network/Types/Responses/HandoverInviteResponses'
import { PackageRecurrence } from '@/Network/Types/Requests/HandoverInviteRequests'
import { formatCurrency } from '@/utils/formatters'
import { formatHourMinuteInOffset } from '@/utils/date'

const DEFAULT_STATION_UTC_OFFSET = '-03:00'

const props = defineProps<{
  stations: StationSummary[]
  recurrence: PackageRecurrence
}>()

const RECURRENCE_LABELS: Record<string, string> = {
  SINGLE: 'Único',
  WEEKLY: 'Semanal',
  BIWEEKLY: 'Quinzenal',
  MONTHLY_ABCDE: 'Mensal ABCDE'
}

const columns = ['Data', 'Horário', 'Posição', 'Turno', 'Recorrência', 'Valor']

const recurrenceLabel = computed(() => RECURRENCE_LABELS[props.recurrence] ?? props.recurrence)

const formatStationDate = (dateStr: string) => {
  try {
    return format(parseISO(dateStr), 'dd/MM/yyyy')
  } catch {
    return dateStr
  }
}

const formatStationTimeRange = (
  startTime?: string | null,
  endTime?: string | null,
  timezone?: string | null
) => {
  if (!startTime || !endTime) return '-'

  const offset = timezone ?? DEFAULT_STATION_UTC_OFFSET
  const start = formatHourMinuteInOffset(startTime, offset)
  const end = formatHourMinuteInOffset(endTime, offset)
  if (!start || !end) return '-'

  return `${start} às ${end}`
}

const formatValue = (value?: number | null) => {
  if (value === null || value === undefined) return '-'
  return formatCurrency(value)
}
</script>
